import type { Chart, ChartData, ChartOptions, PluginOptionsByType } from 'chart.js';
import commaNumber from 'comma-number';
import type { RefObject } from 'react';
import { Bar } from 'react-chartjs-2';
import styled from 'styled-components';

import { Flex, Space, VFlex } from '@/components/base';
import ScrollView from '@/components/Common/ScrollView';
import Heading from '@/components/Typography/Heading';
import { MainText } from '@/components/Typography/NamedTypo';

import FilteredInfoArea from './FilteredInfoArea';

type Props = {
  trendChartData: ChartData<'bar'>;
  trendChartOptions: ChartOptions<'bar'>;
  chartRef: RefObject<Chart<'bar'>>;
  searchValue: string;
  selectedChartBar: SelectedChartBar;
  trendData: FeedbackListTrendDataT;
  filteredCount: number;
  backgroundChartArea: PluginOptionsByType<'bar'>['backgroundChartArea'];
};

const FeedbackTrendChartArea = (props: Props) => {
  return (
    <TrendWrapper>
      <Space h="16px" />
      <Flex j="space-between">
        <Flex
          style={{
            height: 200,
            width: 'calc(100% - 200px)',
            cursor: 'pointer',
          }}
        >
          <Bar
            key="feedback-trend-chart"
            data={props.trendChartData}
            options={props.trendChartOptions}
            ref={props.chartRef}
            plugins={[props.backgroundChartArea]}
          />
        </Flex>
        <VFlex
          a="flex-end"
          j="flex-end"
          style={{ paddingBottom: 8, height: 200 }}
        >
          <ScrollView>
            <VFlex a="flex-end">
              {props.selectedChartBar === null ? (
                <>
                  <Heading>{commaNumber(props.trendData.count || 0)}</Heading>
                  <Space h="4px" />
                  <MainText weight="sb">Total feedback</MainText>
                </>
              ) : (
                <FilteredInfoArea
                  filteredTotal={props.filteredCount}
                  total={props.trendData.count || 0}
                />
              )}
            </VFlex>
          </ScrollView>
        </VFlex>
      </Flex>
    </TrendWrapper>
  );
};

const TrendWrapper = styled(VFlex)`
  position: relative;
  margin: 0 24px;
  padding: 16px;
  border: 1px solid ${(props) => props.theme.colors.gray300};
  border-radius: 8px;
  height: 274px;
`;

export default FeedbackTrendChartArea;
